module.exports = __webpack_public_path__ + "img/heightMap.3408054e.png";